export default __webpack_public_path__ + "static/media/cloud.21e7e3aa.png";